(() => {
  const DURATION = 3400;
  const ENTRANCE_DELAY = 650;
  const PARTICLES_DESKTOP = 12;
  const PARTICLES_MOBILE = 8;

  const mount = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const headerGroup = document.querySelector('#header-group');
    const logo = headerGroup?.querySelector('.header-logo__image-container');
    if (!headerGroup || !logo || headerGroup.querySelector('.nn-celestial-signature')) return;

    const signature = document.createElement('div');
    signature.className = 'nn-celestial-signature';
    signature.setAttribute('aria-hidden', 'true');
    signature.innerHTML =
      '<span class="nn-celestial-signature__atmosphere"></span>' +
      '<span class="nn-celestial-signature__star"></span>' +
      '<span class="nn-celestial-signature__particles"></span>';
    headerGroup.appendChild(signature);

    const star = signature.querySelector('.nn-celestial-signature__star');
    const atmosphere = signature.querySelector('.nn-celestial-signature__atmosphere');
    const particleField = signature.querySelector('.nn-celestial-signature__particles');
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const particleCount = isMobile ? PARTICLES_MOBILE : PARTICLES_DESKTOP;

    const groupRect = headerGroup.getBoundingClientRect();
    const logoRect = logo.getBoundingClientRect();
    const viewportWidth = document.documentElement.clientWidth;
    const centreY = logoRect.top + logoRect.height / 2 - groupRect.top;
    const startX = -Math.max(150, viewportWidth * 0.18);
    const endX = viewportWidth + Math.max(150, viewportWidth * 0.16);
    const travel = endX - startX;
    const logoCentreX = logoRect.left + logoRect.width / 2;
    const logoProgress = Math.max(0.2, Math.min(0.8, (logoCentreX - startX) / travel));

    const path = [
      { transform: `translate3d(${startX}px, ${centreY + 13}px, 0) scale(.68)`, opacity: 0, offset: 0 },
      { transform: `translate3d(${startX + travel * 0.08}px, ${centreY + 10}px, 0) scale(.82)`, opacity: 1, offset: 0.1 },
      { transform: `translate3d(${startX + travel * 0.36}px, ${centreY + 4}px, 0) scale(.96)`, opacity: 1, offset: 0.36 },
      { transform: `translate3d(${startX + travel * logoProgress}px, ${centreY}px, 0) scale(1.08)`, opacity: 1, offset: logoProgress },
      { transform: `translate3d(${startX + travel * 0.78}px, ${centreY - 5}px, 0) scale(.94)`, opacity: 0.96, offset: 0.78 },
      { transform: `translate3d(${endX}px, ${centreY - 10}px, 0) scale(.76)`, opacity: 0, offset: 1 }
    ];

    signature.classList.add('is-running');

    star.animate(path, {
      duration: DURATION,
      delay: ENTRANCE_DELAY,
      easing: 'cubic-bezier(.32,.02,.18,1)',
      fill: 'both'
    });

    atmosphere.animate(
      path.map((frame, index) => ({
        transform: `${frame.transform} translate3d(-46%, -46%, 0) scale(${index === 3 ? 1.16 : 1})`,
        opacity: index === 0 || index === path.length - 1 ? 0 : index === 3 ? 0.78 : 0.42,
        offset: frame.offset
      })),
      {
        duration: DURATION,
        delay: ENTRANCE_DELAY,
        easing: 'cubic-bezier(.32,.02,.18,1)',
        fill: 'both'
      }
    );

    const glowDelay = ENTRANCE_DELAY + DURATION * logoProgress - 160;
    window.setTimeout(() => {
      document.body.classList.add('nn-celestial-logo-glow');
    }, glowDelay);

    const particles = [];
    for (let index = 0; index < particleCount; index += 1) {
      const particle = document.createElement('i');
      particle.className = 'nn-celestial-signature__particle';
      particle.style.setProperty('--nn-particle-size', `${1 + (index % 3) * 0.65}px`);
      particle.style.setProperty('--nn-particle-alpha', `${0.46 + (index % 4) * 0.11}`);
      particleField.appendChild(particle);
      particles.push(particle);
    }

    particles.forEach((particle, index) => {
      const releaseProgress = 0.16 + index * (0.62 / Math.max(1, particleCount - 1));
      const releaseX = startX + travel * releaseProgress;
      const curveY = centreY + 13 - 23 * releaseProgress + Math.sin(releaseProgress * Math.PI) * 2;
      const driftX = 16 + (index % 4) * 7;
      const driftY = (index % 2 === 0 ? 1 : -1) * (4 + (index % 5) * 1.4);
      const particleDelay = ENTRANCE_DELAY + DURATION * releaseProgress;
      const particleDuration = 430 + (index % 4) * 90;

      particle.animate(
        [
          { transform: `translate3d(${releaseX - 16}px, ${curveY}px, 0) scale(.45)`, opacity: 0, offset: 0 },
          { transform: `translate3d(${releaseX}px, ${curveY}px, 0) scale(1)`, opacity: 0.8, offset: 0.18 },
          { transform: `translate3d(${releaseX - driftX}px, ${curveY + driftY}px, 0) scale(.62)`, opacity: 0, offset: 1 }
        ],
        {
          duration: particleDuration,
          delay: particleDelay,
          easing: 'cubic-bezier(.22,.61,.36,1)',
          fill: 'both'
        }
      );
    });

    window.setTimeout(() => {
      document.body.classList.remove('nn-celestial-logo-glow');
      signature.remove();
    }, ENTRANCE_DELAY + DURATION + 900);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => window.setTimeout(mount, 420), { once: true });
  } else {
    window.setTimeout(mount, 420);
  }
})();
